import { __decorate } from "tslib";
import { Message, MessageParamDefinition, MessageType } from 'ircv3';
/** @private */
let UserState = class UserState extends Message {
};
__decorate([
    MessageParamDefinition({
        type: 'channel'
    })
], UserState.prototype, "type", void 0);
UserState = __decorate([
    MessageType('USERSTATE')
], UserState);
export { UserState };
